// @flow
// import ReactDom from 'react-dom';
import Scrollchor from 'react-scrollchor'
import React, { Component } from 'react'

import { State } from '../../types/types'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'

import './styles.scss'

import Masthead from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'
import Profile from '../profile/Profile'
import Challenge from '../challenge/Challenge'
import Cover from '../cover'

import parseSheets from '../../helpers/parseSheets'

import {
  parseCandidates,
  candidatesAsArray,
  parseChallenges
} from './helpers'

import database from '../../database/firebase'

// TODO Set the correct article ID here
// random article to supress error warnings, adjust!
const ARTICLE_ID = '18337786'

const sheetId =
  'https://spreadsheets.google.com/feeds/list/' +
  '17Qv7Lt_4mofGwazj5RxFVurLyOXRzA0uH_eQ4u5B3G4' +
  '/1/public/values?alt=json'

const candidatesRangeInSheet = 5 // aka number of candidates
const currentChallengeCellId = 12

class App extends Component<null, State> {
  handleVote = this.handleVote.bind(this)

  candidates = database.collection('candidates')

  state: State = {}

  // keep track of initial re-renders for deep-linking hack
  updates = 0

  componentDidMount() {
    this.getDatabaseData()
    this.getStaticData()
  }
  componentDidUpdate() {
    // deep linking hack:
    // keep track of initial re-renders (8)
    const initialReRenders = 8
    this.updates += 1

    let hash = window.location.hash.replace('#', '');
    if (hash) {
      // console.log(hash, this.updates)
      // let node = ReactDom.findDOMNode(this.refs[hash]);
      let node = document.getElementById(hash)

      // prevent scroll to hashlink after initial updates
      if (node && this.updates <= initialReRenders) {
        node.scrollIntoView();
      }
    }
  }
  getStaticData() {
    fetch(sheetId)
      .then(res => res.json())
      .then(json => parseSheets(json))
      .then(data => {
        const candidates = parseCandidates(data, candidatesRangeInSheet)

        // provide candidates as array for later mappings
        const asArray = candidatesAsArray(candidates)

        const challengeData = parseChallenges(data, candidatesRangeInSheet, currentChallengeCellId)

        this.setState(prevState => ({
          ...prevState,
          static: {
            challengeData,
            candidates: {
              candidates,
              asArray: asArray
            }
          }
        }))
      })
      .then(() => {
        this.setState({ staticLoaded: true }, () => this.sortCandidates())
      })
  }
  getDatabaseData() {
    this.candidates.get().then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = doc.data()

        const average = data.v / data.p || 0

        this.setState(
          prevState => {
            return {
              ...prevState,
              dynamic: {
                ...prevState.dynamic,
                [data.name]: {
                  data,
                  average
                }
              }
            }
          },
          () => {
            // if we have loaded all (5) candidates, render app
            if (Object.keys(this.state.dynamic).length === candidatesRangeInSheet) {
              this.setState({ dynamicLoaded: true }, () => this.sortCandidates())
            }
          }
        )
      })
    })
  }
  handleVote(vote: number, challenge: string, name: string) {
    console.log(JSON.stringify({ vote, challenge, name }, null, 2))

    const value = vote

    const candidate = this.candidates.doc(name)

    return candidate
      .get()
      .then(c => {
        const data = c.data()

        const newValue = data[challenge].v + value
        const newNumberOfParticipants = data[challenge].p + 1

        const update = {
          [challenge]: {
            v: newValue,
            p: newNumberOfParticipants
          },
          p: data.p + 1,
          v: data.v + value
        }

        return candidate.update(update).then(() => {
          this.setState(prevState => {
            return {
              ...prevState,
              dynamic: {
                ...prevState.dynamic,
                [name]: {
                  average: (data.v + value) / (data.p + 1),
                  data: {
                    ...prevState.dynamic[name].data,
                    [challenge]: {
                      v: newValue,
                      p: newNumberOfParticipants
                    },
                    p: data.p + 1,
                    v: data.v + value
                  }
                }
              }
            }
          })
        })
      })
      .then(() => {
        console.log('voting success')
        localStorage.setItem('vote-' + challenge + '-value-' + name, value)
      })
      .catch(error => {
        console.log('voting failed')
        console.log(error)
        return error
      })
  }
  sortCandidates() {
    if (!this.state.dynamicLoaded || !this.state.staticLoaded) return

    const candidatesArray = [...this.state.static.candidates.asArray]

    candidatesArray.sort((a, b) => {
      return this.state.dynamic[b.name]['average'] - this.state.dynamic[a.name]['average']
    })

    this.setState(prevState => {
      return {
        ...prevState,
        static: {
          ...prevState.static,
          candidates: {
            ...prevState.static.candidates,
            asArray: candidatesArray
          }
        }
      }
    })
  }
  render() {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />
        {/* TODO Replace the following segment with your project cover */}
        <header className='ui vertical fitted inverted dark-grey background segment'>
          <Cover
            title='Die «Bund»-Wahl-Challenge'
            subtitle='Fünf Jungpolitikerinnen und -politiker im etwas anderen Wahlkampf'
          />
        </header>
        {/* Start Intro - Section */}
        <div className='ui vertical segment fitted inverted dark-grey background intro'>
          <div className='ui text container'>
            <Scrollchor
              to={`#question-${this.state.static &&
                this.state.static.challengeData.currentChallenge}`}
            >

              {/* <div className='ui huge icon info message'>
                <i className='angle double down icon' />
                <div className='content'>
                  <div className='header'>Nicht zum ersten Mal hier?</div>
                  <div>Direkt zur aktuellen Challenge!</div>
                </div>
              </div> */}

            </Scrollchor>
            <p className='ta lead'>
              Wer in den Nationalrat gewählt werden will, muss fit
              sein im Wahlkampf. In der «Bund»-Wahlkampf-Challenge stellen sich
              fünf Jungpolitiker und -politikerinnen den Herausforderungen der
              «Bund»-Redaktion – und Sie bestimmen mit.
            </p>
            <p className='ta author'>
              Von Christoph Aebischer, Martin Erdmann, Christian Zellweger und
              Sandra Niemann (Illustrationen)
            </p>
            <p>
              Wie gut schlagen sich Jungpolitiker und Jungpolitikerinnen im
              Kampf um die Nationalratssitze? Wir haben fünf Kandidaten und
              Kandidatinnen der wählerstärksten Berner Parteien ausgewählt und
              lassen sie gegeneinander zu sechs Herausforderungen antreten.
            </p>
            <p>
              Bis zu den Nationalratswahlen Ende Oktober schalten wir auf dieser
              Plattform laufend die neuen Herausforderungen und die
              dazugehörigen Einsendungen der Kandidaten und Kandidatinnen auf.
            </p>
            <p>Verfolgen Sie die «Bund»-Wahlchallenge und stimmen Sie ab.
              Bei jeder Challenge ist Ihre Bewertung aufs Neue gefragt.
              Eine zusätzliche Wertung kommt jeweils von der «Bund»-Jury.
            </p>
            <p>
              Weiteres zu den Regeln{' '}
              <Scrollchor to='#methodik' id='intro-link-to-method'>
                finden Sie an dieser Stelle
              </Scrollchor>.
            </p>
            <p>Viel Spass!</p>
            <div className='ui huge warning message'>
              <div className='content'>
                <div className='header'>Die Challenge ist zu Ende</div>
                <div>
                  Liebe Leserinnen und Leser, die «Bund»-Wahlchallenge ist am 8. Oktober 2019 zu Ende gegangen.

                  Das ist die Rangliste:
                  <ol>
                    <li>Sandro Tanner (jGrüne) – 3,6</li>
                    <li>Tanja Blume (Juso) – 3,4</li>
                    <li>Michelle Schweizer (JF) – 3,2</li>
                    <li>Sascha Zbinden (jBDP) – 3,0</li>
                    <li>Christoph Henz (jSVP) – 2,0</li>
                  </ol>
                  Welche Erfahrungen die Kandidatinnen und Kandidaten, aber auch die Jury-Mitglieder
                  währen der Wahlchallenge gemacht haben, können Sie in diesem Artikel nachlesen:{' '}
                  <a href="https://www.derbund.ch/news/standard/wc/story/16386499" target="_blank"><b>«Das ist der Sieger der Bund-Wahlchallenge» (Abo+)</b></a>
                  <br />
                  <br/>
                  Und natürlich: Wie haben die Kandidierenden bei den Wahlen am 20. Oktober schliesslich
                  abgeschnitten? Wie ist es ihnen dabei gegangen? Wir haben nachgefragt. Die Antworten
                  lesen Sie in diesem Artikel: <a href="https://www.derbund.ch/20890043" target="_blank"><b>«Wenn der Erste plötzlich Letzter wird» (Abo+)</b></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Intro - Section */}

        {/* Start Navigation - Section */}
        {!this.state.dynamicLoaded || !this.state.staticLoaded ? null : (
          <>
            <div className='ui vertical segment fitted inverted dark-grey background navigation'>
              <div
                className='ui question container'
                style={{ textAlign: 'left' }}
              >
                <h2>
                  <span className='title-text'>Die Herausforderungen</span>
                </h2>
              </div>
              <div className='ui text container'>

                <ul className='nav' id='nav'>
                  <Scrollchor to='#question-1'>
                    <li
                      className={`question-link ${
                        this.state.static &&
                          this.state.static.challengeData.challengeStates[1 + candidatesRangeInSheet] === true
                          ? 'active'
                          : 'inactive'
                        }`}
                      onClick={this.trackNavClicks}
                    >
                      {`1. ${this.state.static.challengeData.challengeTitles[1 - 1]}`}
                    </li>
                  </Scrollchor>
                  <Scrollchor to='#question-2'>
                    <li
                      className={`question-link ${
                        this.state.static &&
                          this.state.static.challengeData.challengeStates[2 + candidatesRangeInSheet] === true
                          ? 'active'
                          : 'inactive'
                        }`}
                      onClick={this.trackNavClicks}
                    >
                      {this.state.static.challengeData.challengeStates[2 + candidatesRangeInSheet] === true ? `2. ${this.state.static.challengeData.challengeTitles[2 - 1]}` : '2. Zweite Herausforderung'}
                    </li>
                  </Scrollchor>
                  <Scrollchor to='#question-3'>
                    <li
                      className={`question-link ${
                        this.state.static &&
                          this.state.static.challengeData.challengeStates[3 + candidatesRangeInSheet] === true
                          ? 'active'
                          : 'inactive'
                        }`}
                      onClick={this.trackNavClicks}
                    >
                      {this.state.static.challengeData.challengeStates[3 + candidatesRangeInSheet] === true ? `3. ${this.state.static.challengeData.challengeTitles[3 - 1]}` : '3. Dritte Herausforderung'}
                    </li>
                  </Scrollchor>
                  <Scrollchor to='#question-4'>
                    <li
                      className={`question-link ${
                        this.state.static &&
                          this.state.static.challengeData.challengeStates[4 + candidatesRangeInSheet] === true
                          ? 'active'
                          : 'inactive'
                        }`}
                      onClick={this.trackNavClicks}
                    >
                      {this.state.static.challengeData.challengeStates[4 + candidatesRangeInSheet] === true ? `4. ${this.state.static.challengeData.challengeTitles[4 - 1]}` : '4. Vierte Herausforderung'}
                    </li>
                  </Scrollchor>
                  <Scrollchor to='#question-5'>
                    <li
                      className={`question-link ${
                        this.state.static &&
                          this.state.static.challengeData.challengeStates[5 + candidatesRangeInSheet] === true
                          ? 'active'
                          : 'inactive'
                        }`}
                      onClick={this.trackNavClicks}
                    >
                      {this.state.static.challengeData.challengeStates[5 + candidatesRangeInSheet] === true ? `5. ${this.state.static.challengeData.challengeTitles[5 - 1]}` : '5. Fünfte Herausforderung'}
                    </li>
                  </Scrollchor>
                  <Scrollchor to='#question-6'>
                    <li
                      className={`question-link ${
                        this.state.static &&
                          this.state.static.challengeData.challengeStates[6 + candidatesRangeInSheet] === true
                          ? 'active'
                          : 'inactive'
                        }`}
                      onClick={this.trackNavClicks}
                    >
                      {`6. ${this.state.static.challengeData.challengeTitles[6 - 1]}`}
                    </li>
                  </Scrollchor>
                </ul>
                {/* <div className='ui huge info message'>
                  <div className='content'>
                    <div className='header'>Wir suchen die Leser-Challenge</div>
                    <div>Nicht nur bei der Bewertung sind Sie gefragt, lieber Leser, liebe Leserin. Die letzte
                    Herausforderung soll nämlich von Ihnen kommen. Senden Sie uns bis zum 15. September. ihren Vorschlag für die
                  Publikums-Challenge <b>an die Mail-Adresse <a href='mailto:bern@derbund.ch?subject=Wahlchallenge-Vorschlag&cc=christoph.aebischer@derbund.ch,christian.zellweger@derbund.ch,martin.erdmann@derbund.ch'>bern@derbund.ch</a></b>. Die Jury
                          wird eine der Ideen auswählen und den Kandidaten und Kandiatinnen vorlegen.
                {' '}<b>Die ausgewählte Idee wird mit einem Jahresabo für den «Bund» prämiert.</b>
                    </div>
                  </div>
                      </div> */}
              </div>
            </div>
            {/* End Navigation-Section */}
            {/* Start Candidates - Section */}
            <div className='ui vertical segment fitted inverted dark-grey background candidates'>
              <div
                className='ui question container'
                id='candidates-1'
                style={{ textAlign: 'left' }}
              >
                <h2>
                  <span className='title-text'>
                    Die Kandidatinnen und Kandidaten
                  </span>
                  <Scrollchor to={'#nav'}>
                    <div className='top-link'>
                      <div className='arrow-text'>nach oben</div>{' '}
                      <i className='chevron up icon' />
                    </div>
                  </Scrollchor>
                </h2>
              </div>
              <div className='ui text container'>
                <div>Das sind die Jungpolitiker und -politikerinnen,
                    die sich der «Bund»-Herausforderung gestellt haben.
                    Die Reihenfolge entspricht der Platzierung, die sich
                    nach sechs Runden Publikums- und Juryvoting ergeben hat.
              </div>
                <br />
                {this.state.static.candidates.asArray.map(
                  (candidate, index) => {
                    return (
                      <Profile
                        key={index}
                        name={candidate.name}
                        fullName={candidate.fullName}
                        avatarSrc={candidate.image}
                        description={candidate.description}
                        byline={candidate.party}
                        verdicts={candidate.verdicts}
                        dynamicEntries={this.state.dynamic[candidate.name]}
                        staticEntries={candidate.entries}
                        portraitLink={candidate.portraitLink}
                        amountOfChallenges={this.state.static.challengeData.currentChallenge}

                      />
                    )
                  }
                )}
              </div>
            </div>
            {/* End Candidates-Section */}
            {/* Start Challenges - Section */}
            <div className='ui vertical segment fitted inverted dark-grey background challenges'>
              {this.state.static.challengeData.challengeStates[1 + candidatesRangeInSheet] && (
                <Challenge
                  number={1}
                  data={this.state}
                  title={this.state.static.challengeData.challengeTitles[1 - 1]}
                  explainerText={this.state.static.challengeData.challengeExplainerTexts[1 - 1]}
                  voteHandler={this.handleVote}
                />
              )}
              {this.state.static.challengeData.challengeStates[2 + candidatesRangeInSheet] && (
                <Challenge
                  number={2}
                  title={this.state.static.challengeData.challengeTitles[2 - 1]}
                  data={this.state}
                  explainerText={this.state.static.challengeData.challengeExplainerTexts[2 - 1]}
                  voteHandler={this.handleVote}
                />
              )}
              {this.state.static.challengeData.challengeStates[3 + candidatesRangeInSheet] && (
                <Challenge
                  number={3}
                  title={this.state.static.challengeData.challengeTitles[3 - 1]}
                  data={this.state}
                  explainerText={this.state.static.challengeData.challengeExplainerTexts[3 - 1]}
                  voteHandler={this.handleVote}
                />
              )}
              {this.state.static.challengeData.challengeStates[4 + candidatesRangeInSheet] && (
                <Challenge
                  number={4}
                  title={this.state.static.challengeData.challengeTitles[4 - 1]}
                  data={this.state}
                  explainerText={this.state.static.challengeData.challengeExplainerTexts[4 - 1]}
                  voteHandler={this.handleVote}
                />
              )}
              {this.state.static.challengeData.challengeStates[5 + candidatesRangeInSheet] && (
                <Challenge
                  number={5}
                  title={this.state.static.challengeData.challengeTitles[5 - 1]}
                  data={this.state}
                  explainerText={this.state.static.challengeData.challengeExplainerTexts[5 - 1]}
                  voteHandler={this.handleVote}
                />
              )}
              {this.state.static.challengeData.challengeStates[6 + candidatesRangeInSheet] && (
                <Challenge
                  number={6}
                  title={this.state.static.challengeData.challengeTitles[6 - 1]}
                  data={this.state}
                  explainerText={this.state.static.challengeData.challengeExplainerTexts[6 - 1]}
                  voteHandler={this.handleVote}
                />
              )}
            </div>
            {/* End Challenges-Section */}
            {/* TODO Add your credits in this component */}
            <div className='ui vertical fitted attached segment' id='methodik'>
              <div className='ui text container methodik'>
                <h3>Allgemeine Hinweise</h3>
                <div className='list'>
                  <ul>
                    <li>
                      Die fünf Kandidaten und Kandidatinnen stammen aus den fünf
                      wählerstärksten Parteien der Nationalratswahlen von 2015.
                      Von den Listen der entsprechenden Jungparteien hat die
                      «Bund»-Redaktion fünf Kandidaten und Kandidatinnen
                      ausgewählt.
                    </li>
                    <li>
                      Die Aufgaben stammen aus der «Bund»-Redaktion.
                      Die Teilnehmenden erhalten die Aufgaben jeweils einige Wochen vor Erscheinen.
                      Sie sind in der Umsetzung ihres Beitrages im Rahmen der jeweiligen Challenge frei.
                    </li>
                    <li>
                      Die Jury besteht aus den «Bund»-Redaktoren Christoph
                      Aebischer, Martin Erdmann, Christian Zellweger und der
                      «Bund»-Mitarbeiterin Carole Güggi. Die Wertung der Jury
                      wird mit 20 Prozent gewichtet, die Wertung aus dem
                      Publikums-Rating entsprechend mit 80 Prozent.
                    </li>
                  </ul>
                  <Scrollchor to='#intro-link-to-method'>Zurück</Scrollchor>
                </div>
              </div>
            </div>
            <Footer
              hideTop
              hidePortfolioTeaser
              articleId={ARTICLE_ID}
              credits={[
                ['Idee, Konzept, Text', 'Christoph Aebischer, Martin Erdmann, Christian Zellweger'],
                ['Foto', 'Beat Mathys, Adrian Moser, Marco Raho'],
                ['Videos', 'Martin Erdmann, Christian Zellweger'],
                ['Illustrationen', 'Sandra Niemann'],
                ['Programmierung', 'Christian Zellweger'],
                [
                  'Interaktiv-Team Tamedia',
                  ['Marc Brupacher, Kaspar Manz, Mathias Lutz']
                ]
              ]}
            />
          </>
        )}
      </div>
    )
  }
}

export default App
